// extracted by mini-css-extract-plugin
export default {"dialog":"CouponExpiredDialog_dialog__P8D6o","icon":"CouponExpiredDialog_icon__BeO1b","formButton":"CouponExpiredDialog_formButton__NAqmb"};